var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$imagePreviewDialog.model)?_c('image-preview-dialog'):_vm._e(),_c('navigator-bar'),_c('router-view'),_c('feedback-area')],1)}
var staticRenderFns = []

export { render, staticRenderFns }